import service from "@/router/request";

/**
 * 查询活动信息
 * @param params 查询条件
 */
export async function getEventInfoApi(params) {
    const res = await service.get('/mobile/getProjectInfo', {
        params
    });
    if (res.data.code === 0 && res.data.data) {
        return res.data.data;
    }
    return Promise.reject(new Error(res.data.message));
}

/**
 * 查询专家信息
 * @param params 查询条件
 */
export async function getUserInfoApi(params) {
    const res = await service.get('/mobile/getExpertsByName', {
        params
    });
    if (res.data.code === 0 && res.data.data) {
        return res.data.data;
    }
    return Promise.reject(new Error(res.data.message));
}

/**
 * 获取验证码
 * @param params 查询条件
 */
export async function getSmsCodeApi(params) {
    const res = await service.get('/mobile/sendSignSmsCode', {
        params
    });
    if (res.data.code === 0 && res.data.data) {
        return res.data.data;
    }
    return Promise.reject(new Error(res.data.message));
}

/**
 * 签到
 */
export async function submitSignApi(data) {
    const res = await service.post('/mobile/signIn', data);
    if (res.data.code === 0) {
        return res.data.message;
    }
    return Promise.reject(new Error(res.data.message));
}